module.exports = __webpack_public_path__ + "static/img/3.b623401.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/3.png
// module id = z/NZ
// module chunks = 0